import { render } from "./FoodRunnerModal.vue?vue&type=template&id=1c55ff53&scoped=true"
import script from "./FoodRunnerModal.vue?vue&type=script&lang=js"
export * from "./FoodRunnerModal.vue?vue&type=script&lang=js"

import "./FoodRunnerModal.vue?vue&type=style&index=0&id=1c55ff53&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c55ff53"]])

export default __exports__